<section>
    <div class="container">
        <compass-select-layer-group [setup]="selectSetup"></compass-select-layer-group>
    </div>
</section>